import { IKitchen, IResponse } from "../common/interfaces";
import { request } from "./AjaxService";

export const SalesFloorService = {
  createSession: async (payload: Record<string, any>): Promise<IResponse<any>> => await request.post('kitchen', payload),
  addOrder: async (kitchenId: string, payload: Record<string, any>): Promise<IResponse<any>> => await request.post(`kitchen/${kitchenId}/order`, payload),
  show: async (kitchenId: string): Promise<IResponse<IKitchen>> => {
    console.log(`🌐 [SALES FLOOR SERVICE] Calling API: GET /kitchen/${kitchenId}?display_type=floor`);
    const response = await request.get(`kitchen/${kitchenId}`, { display_type: 'floor' });
    console.log(`📡 [SALES FLOOR SERVICE] API Response:`, response);
    return response;
  },
  update: async (kitchenId: string, payload: Record<string, any>): Promise<IResponse<any>> => await request.put(`kitchen/${kitchenId}`, payload),
  trackOrderStatus: async (orderId: string, payload: Record<string, any>): Promise<IResponse<any>> => await request.put(`order/${orderId}/change/status`, payload),
  getHistoryOrderStatus: async (orderId: string): Promise<IResponse<any>> => await request.get(`order/${orderId}/history`),
  setAppOrderStatus: async (orderId: string, payload: Record<string, any>): Promise<IResponse<any>> => await request.put(`orders/${orderId}/status`, payload),
}
